import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { websiteRequest } from 'src/editor/shared/utils/request'
import { WebsitePageResource } from 'src/shared/types/website-page-interface'
import {
  WebsiteStylesInterface,
  WebsiteThemeForSaveInterface,
  WebsiteThemeInterface,
} from 'src/shared/types/website-settings-types'

export interface UpdateWebsiteDataInterface {
  name?: string
  defaultLocale?: PageLocaleEnum
  style?: WebsiteStylesInterface
  theme?: WebsiteThemeForSaveInterface
}

interface WebsiteDataResponseInterface extends WebsitePageResource {
  theme: WebsiteThemeInterface
  style: WebsiteStylesInterface
}

export const updateWebsite = (id: number, data: UpdateWebsiteDataInterface) =>
  websiteRequest<WebsiteDataResponseInterface>(`websites/${id}/edit`, 'PUT', {
    data,
  })

interface UpdateWebsiteResourceInterface {
  id: number
  domainId?: number
  name: string
  homePagePath?: string
  locale: PageLocaleEnum
  locales: PageLocaleEnum[]
}

interface WebsiteResourceResponseInterface {
  id: number
  name: string
  locale: PageLocaleEnum
  locales: PageLocaleEnum[]
  active: boolean
  domainId: number
  createdAt: string
}

export const updateWebsiteResource = ({
  id,
  domainId,
  name,
  homePagePath,
  locale,
  locales,
}: UpdateWebsiteResourceInterface) =>
  websiteRequest<WebsiteResourceResponseInterface>(`websites/${id}`, 'PUT', {
    data: {
      domainId,
      name,
      homePagePath,
      locale,
      locales,
    },
  })

interface AddWebsiteLocaleDataInterface {
  id: number
  locale: PageLocaleEnum
}

export const addWebsiteLocale = ({
  id,
  locale,
}: AddWebsiteLocaleDataInterface) =>
  websiteRequest<void>(`websites/${id}/add-locale`, 'POST', {
    data: {
      locale,
    },
  })

interface RemoveWebsiteLocaleDataInterface {
  id: number
  locale: PageLocaleEnum
}

export const removeWebsiteLocale = ({
  id,
  locale,
}: RemoveWebsiteLocaleDataInterface) =>
  websiteRequest<void>(`websites/${id}/remove-locale`, 'POST', {
    data: {
      locale,
    },
  })

interface CopyWebsitePagesDataInterface {
  id: number
  locale: PageLocaleEnum
}

export const copyWebsitePages = ({
  id,
  locale,
}: CopyWebsitePagesDataInterface) =>
  websiteRequest<void>(`websites/${id}/copy-pages`, 'POST', {
    data: {
      locale,
    },
  })
